import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=81466fe2&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=81466fe2&prod&scoped=true&lang=css"
import style1 from "./product-detail.vue?vue&type=style&index=1&id=81466fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81466fe2",
  null
  
)

export default component.exports